<div class="mobile-create-password">
  <div class="cp-status-spacer"></div>

  <button type="button" class="cp-back-btn" (click)="navigateBack()">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>

  <h1>{{ 'CREATE_PASSWORD.TITLE' | translate }}</h1>
  <p class="cp-subtitle">{{ 'CREATE_PASSWORD.SUBTITLE' | translate }}</p>

  <div class="cp-field">
    <label for="cp-new-password">{{ 'CREATE_PASSWORD.LABEL_NEW' | translate }}</label>
    <div class="cp-input-wrap">
      <input
        id="cp-new-password"
        class="cp-input"
        [(ngModel)]="newPasswordValue"
        [type]="showNewPassword ? 'text' : 'password'"
        [placeholder]="'CREATE_PASSWORD.PLACEHOLDER_NEW' | translate"
      />
      <button type="button" class="cp-eye-btn" (click)="toggleNewPassword()">
        <i class="bi" [ngClass]="showNewPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
      </button>
    </div>
    <span *ngIf="newPasswordError" class="cp-error">{{ newPasswordError | translate }}</span>
  </div>

  <div class="cp-field">
    <label for="cp-confirm-password">{{ 'CREATE_PASSWORD.LABEL_CONFIRM' | translate }}</label>
    <div class="cp-input-wrap">
      <input
        id="cp-confirm-password"
        class="cp-input"
        [(ngModel)]="confirmPasswordValue"
        [type]="showConfirmPassword ? 'text' : 'password'"
        [placeholder]="'CREATE_PASSWORD.PLACEHOLDER_CONFIRM' | translate"
      />
      <button type="button" class="cp-eye-btn" (click)="toggleConfirmPassword()">
        <i class="bi" [ngClass]="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
      </button>
    </div>
    <span *ngIf="confirmPasswordError" class="cp-error">{{ confirmPasswordError | translate }}</span>
  </div>

  <p class="cp-request-error" *ngIf="requestError">{{ requestError | translate }}</p>
  <p class="cp-success-msg" *ngIf="successMessage">{{ successMessage | translate }}</p>

  <button type="button" class="cp-save-btn" (click)="validateAndSubmit()" [disabled]="isLoading">
    <span *ngIf="!isLoading">{{ 'CREATE_PASSWORD.SAVE_BTN' | translate }}</span>
    <i *ngIf="isLoading" class="bi bi-arrow-repeat cp-spinner"></i>
  </button>

  <div class="cp-home-indicator-spacer"></div>
</div>
